import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { CheckCircleTwoTone, ExclamationCircleTwoTone } from "@ant-design/icons";
import DashboardConstants from "./DashboardConstants";
const ShortfallValueWithIcon = ({ shortfallValue }) => {
    if (shortfallValue !== 0 && !shortfallValue) {
        return _jsx(_Fragment, { children: "\u2014" });
    }
    const icon = shortfallValue <= 0
        ? _jsx(CheckCircleTwoTone, { twoToneColor: DashboardConstants.SUCCESS_ICON_COLOR })
        : _jsx(ExclamationCircleTwoTone, { twoToneColor: DashboardConstants.WARNING_ICON_COLOR });
    const textColor = (!!shortfallValue)
        ? (shortfallValue <= 0 ? DashboardConstants.SUCCESS_ICON_COLOR : DashboardConstants.WARNING_ICON_COLOR)
        : undefined;
    return (_jsxs(_Fragment, { children: [_jsx("span", { style: { color: textColor }, children: shortfallValue }), "\u00A0", shortfallValue ? icon : null] }));
};
export default ShortfallValueWithIcon;
